import { keyframes as keyframes_bokeh } from '@vimeo/bokeh';

export const OPACITY_FROM_HIDDEN_TO_VISIBLE_KEYFRAMES = keyframes_bokeh`
  0% { 
    opacity: 0;  
  }
  100% { 
    opacity: 1;
  }
`;
